import { render } from "./App.vue?vue&type=template&id=f9d77c92&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=f9d77c92&lang=scss"

import exportComponent from "/codebuild/output/src1205619327/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__